// extracted by mini-css-extract-plugin
export default {"dodoLogo":"styles_dodoLogo__S0PU3","container":"styles_container__gGbxv","content":"styles_content__iuknh","modalOpened":"styles_modalOpened__uVp06"};